import { createContext } from "react";
const TabListContext = createContext(null);
export {
  TabListContext
};
